const SIZES = ["sm", "md", "lg"];
export {
  SIZES as S
};
